import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_WorldGUI_Img1 from '../images/balloonsodyssey/images-05.png';


export default function BalloonsOdyssey_WorldGUI() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: world GUI"
        description="Panel fully designed in Adobe Illustrator."
        images={[BalloonsOdyssey_WorldGUI_Img1]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}